var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInstagramMobileBookmark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 23,
  viewBox: "0 0 20 23",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M19 0H1a1 1 0 0 0-1 1v20.998l.006.112c.085.803 1.072 1.192 1.682.614l8.087-7.667 8.557 7.685c.644.578 1.668.121 1.668-.744V1a1 1 0 0 0-1-1m-1 2v17.756l-7.575-6.803-.1-.08a1 1 0 0 0-1.256.098L2 19.67V2z"
})));
export default SvgInstagramMobileBookmark;